import type { MappingNode } from "../../../interfaces/MappingNode";
import { getMappingNode, mappingTreeToSublevels } from "../../../utils/mapping";
import type { Filter } from "./filterTypes";

export const isChecked = (filter: Filter, checkedFilters: Filter[]) =>
  checkedFilters.some((checkedFilter) => checkedFilter.id === filter.id);

export const filterCanBeSelected = (
  filter: Filter,
  checkedFilters: Filter[],
  mappingTree: MappingNode,
): boolean => {
  return (
    checkedFilters.length === 0 ||
    isHigherNodeThanAllChecked(filter, checkedFilters, mappingTree) ||
    isChildOfCheckedParent(filter, checkedFilters, mappingTree) ||
    isParentOfCheckedChild(filter, checkedFilters, mappingTree)
  );
};

const isHigherNodeThanAllChecked = (
  filter: Filter,
  checkedFilters: Filter[],
  mappingTree: MappingNode,
): boolean => {
  const sublevels = mappingTreeToSublevels(mappingTree);
  const filterDepth = sublevels.findIndex(
    (sublevel) => sublevel[0].key === filter.key,
  );
  const lowestCheckedDepth = Math.min(
    ...checkedFilters
      .map((checkedFilter) =>
        sublevels.findIndex(
          (sublevel) => sublevel[0].key === checkedFilter.key,
        ),
      )
      .filter((depth) => depth !== -1),
  );
  return filterDepth <= lowestCheckedDepth;
};

const isChildOfCheckedParent = (
  filter: Filter,
  checkedFilters: Filter[],
  mappingTree: MappingNode,
): boolean => {
  return checkedFilters.some((checkedFilter) => {
    const subtree = getMappingNode(checkedFilter.id, mappingTree);
    if (!subtree)
      throw new Error(`Filter ${checkedFilter.id} not in mapping tree`);
    const node = getMappingNode(filter.id, subtree);
    if (node) return true;
    else return false;
  });
};

export const isParentOfCheckedChild = (
  filter: Pick<Filter, "id">,
  checkedFilters: Pick<Filter, "id">[],
  mappingTree: MappingNode,
): boolean => {
  const filterSubtree = getMappingNode(filter.id, mappingTree);
  if (!filterSubtree)
    throw new Error(`Filter ${filter.id} not in mapping tree`);
  return checkedFilters.some(
    (checkedFilter) =>
      checkedFilter.id !== filter.id &&
      !!getMappingNode(checkedFilter.id, filterSubtree),
  );
};
